import { useQuery } from '@tanstack/react-query';
import { DictResponse } from '@spilca/order_ts/v1/order/enum_pb';
import { QUERY_KEYS } from '@monorepo/helpers';
import { useI18n } from '@monorepo/i18n';
import { translateNormalizedDictionary } from '@monorepo/dictionary';
import { REQUEST_TYPES, useGetRequest } from '@monorepo/requests';

const useGetDeliveryConditions = (
  filter: object | undefined,
  active: string | null = null
) => {
  const { t } = useI18n();
  const getDeliveryConditions = useGetRequest(
    REQUEST_TYPES.GET_ORDERS_DELIVERY_CONDITION_REQUEST
  );

  return useQuery({
    queryKey: [QUERY_KEYS.LIST_ORDERS_DELIVERY_CONDITIONS, filter],
    queryFn: (d): Promise<DictResponse.AsObject> =>
      getDeliveryConditions({ ...d, active }),
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 10*60*1000,
    gcTime: 60*1000,
    placeholderData: (previousData) => previousData,
    select: translateNormalizedDictionary(
      ({ name }) => t(`deliverycondition.${name}`),
      null,
      'id',
      (item) => `deliverycondition-${item.id}`
    )
  });
};

export default useGetDeliveryConditions;
